import { useDialog } from 'muibox';
import { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';
import { OnlyFansMetrics } from './useSextforceMetricsCampaignsOverview';
import useSubscriber from './useSubscriber';

const useSextforceMetricsCampaignsCreate = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const dialog = useDialog();
    const axios = useAxios();
    const { data: subscriber } = useSubscriber();

    const [isCreateCampaignLoading, setIsCreateCampaignLoading] = useState<boolean>(false);

    const createCampaign = async (name: string): Promise<OnlyFansMetrics | null> => {
        if (userContext.jwtToken && settingsContext.apiKey && 'userId' in params && params.userId && subscriber) {
            const query: string = `${settingsContext.routes.onlyFans.base}${params.userId}/campaigns`;

            setIsCreateCampaignLoading(true);

            const data = await axios
                .post(query, { name })
                .then(response => {
                    if (response.status === 200) {
                        return response.data;
                    } else {
                        return Promise.reject(response.data);
                    }
                })
                .then(newCampaign => {
                    setIsCreateCampaignLoading(false);

                    return newCampaign as OnlyFansMetrics;
                })
                .catch(error => {
                    console.error(error);

                    setIsCreateCampaignLoading(false);

                    handleHttpError(error, dialog);

                    return null;
                });

            return data;
        }

        return null;
    };

    return { createCampaign, isCreateCampaignLoading };
};

export default useSextforceMetricsCampaignsCreate;
